import SearchMapper from '../mappings/search-mapper';

import { VUwebSearchService, Query } from '@/shared/services/azure-search-service';
import { ISearchResult } from '../models/search-model';

export class PeopleService {
    private mapper = new SearchMapper();

    constructor() {}

    public getSearchResults = (azureService: VUwebSearchService, query: Query): Promise<any> => {
        return new Promise((resolve, reject) => {
            azureService.search(query)
            .then((result: any) => {
                resolve({
                    count: result['@odata.count'], 
                    results: result.value.map((result: ISearchResult) => this.mapper.mapSearchResult(result))
                });
            }).catch((error: any) => {
                reject(error);
            })
        });
    }
}